import React, { useState, useEffect } from "react";
import { axiosBearerSite } from "../../../api";
import CustomersCarousel from "./customersCarousel.js";
import {
  CustomersSection,
  CurtomersHeaderSection,
  CustomersTitle,
  CustomersText,
  CustomersCarouselImageContainer,
  CustomersCarouselImage,
} from "./customers.styles.js";

const Customers = ({ language }) => {
  language = language === "br" ? (language = "pt") : language;

  const [title, setTitle] = useState({
    pt: "Conheça nossos clientes",
    en: "Meet our customers",
    es: "Conoce a nuestros clientes",
  });

  const [subtitle, setSubtitle] = useState({
    pt: "Empresas que confiam nos times de especialistas em transformação digital da LEVTY.",
    en: "Companies that trust LEVTY's teams of experts in digital transformation.",
    es: "Empresas que confían en los equipos de expertos en transformación digital de LEVTY.",
  });

  const [isActive, setIsActive] = useState(false);
  const [customersLogos, setCustomersLogos] = useState([]);

  useEffect(() => {
    getCustomersSession();
  }, []);

  const getCustomersSession = async () => {
    try {
      const res = await axiosBearerSite.post(
        "site/com.levty/levtyFacade/getClientSection",
        {}
      );

      if (res && res.data) {
        let data = res.data;
        setTitle(data.title);
        setSubtitle(data.subtitle);
        setCustomersLogos(data.logos);
      }
      setIsActive(true);
    } catch (error) {
      setIsActive(false);
    }
  };  
  
  return (
    <>
      {isActive && (
        <CustomersSection>
          
          <CurtomersHeaderSection>
            <CustomersTitle>{title[language]}</CustomersTitle>
            <CustomersText>{subtitle[language]}</CustomersText>
          </CurtomersHeaderSection>

            <CustomersCarousel>
              {customersLogos &&
                    customersLogos.map((customersLogo, index) => {
                      return (
                        <CustomersCarouselImageContainer key={"carousel" + index}>
                          <CustomersCarouselImage
                            src={customersLogo}
                            alt={"carousel" + index}
                            key={"carousel" + index}
                          />
                        </CustomersCarouselImageContainer>
                      );
                    })}
            </CustomersCarousel>          
        </CustomersSection>
      )}
    </>
  );
};

export default Customers;
